import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {DiscountModel} from '../../../../models/DiscountModel';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {NumAnnoFilterComponent} from '../../../general-components/filter/num-anno-filter/num-anno-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {ProviderFilterComponent} from '../../../general-components/filter/provider-filter/provider-filter.component';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {UserModel} from '../../../../models/UserModel';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {DiscountService} from '../service-discount/discount.service';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {BaseGeneralComponent} from "../../../BaseGeneralComponent";
@Component({
  selector: 'app-disount-filter',
  templateUrl: './filter-discount.component.html',
  styleUrls: ['./filter-discount.component.scss']
})
export class FilterDiscountComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() filter?: DiscountModel;
  @Input() reportSection?: boolean;

  numAnnoMeseData?: any;
  regionData: any;
  localCustomerData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(ProviderFilterComponent) providerFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(NumAnnoFilterComponent) numAnnoFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private discountService: DiscountService,
              private yearService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new DiscountModel();
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromDiscoutModel(this.filter);
    this.offset = new Offset(10, 0);
    if (this.showNewEditDelete === undefined) {
      let user: UserModel;
      this.showNewEditDelete = true;
      user = JSON.parse(sessionStorage.getItem('user'));
      this.filter.region = user.regionList[0];
      this.filterSingle.region = user.regionList[0];
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
        this.regionService.baseUrl,
        allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
        this.localCustomerService.baseUrl,
        allSettingsFilterModel).pipe();
    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable])
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }

        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];

          this.filter.localCustomer = this.filterSingle.localCustomer;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];

          this.filter.region = this.filterSingle.region;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptYearChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new DiscountModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    sessionStorage.setItem(this.SESSION_STORAGE_LABELS.DISCOUNT_FILTER, JSON.stringify(this.filter));
    this.filterSingle = AllSettingsFilterModel.getFromDiscoutModel(this.filter);
    this.numAnnoFilterComponent.reset();
    this.initFilter(this.filterSingle, isReset);
  }

  getAllFilters() {
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.numAnno = this.numAnnoFilterComponent.optionSelected;
  }
  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.discountService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.discountService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    this.getAllFilters();
    this.getNameSubscribe = this.discountService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Discount_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'Discount_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();

    return date.getFullYear() + '_' +
      String(date.getMonth() + 1).padStart(2, '0') + '_' +
      String(date.getDate()).padStart(2, '0');
  }

  ngOnDestroy(): void {

  }
}
